import { render } from "./SelfCheckView.vue?vue&type=template&id=8a08c130"
import script from "./SelfCheckView.vue?vue&type=script&lang=js"
export * from "./SelfCheckView.vue?vue&type=script&lang=js"

import "../styles/main.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__